import {PrFormValue} from '../../interfaces/process-reports/pr-form-value';
import {PrFormControl} from '../../interfaces/process-reports/pr-form-control';
import {PrFormControlFactory} from './pr-form-control-factory';
import {PrFormControlOption} from '../../interfaces/process-reports/pr-form-control-option';
import {PrFormControlOptionFactory} from './pr-form-control-option-factory';
import {LightCustomerFactory} from '../customers/light-customer-factory';
import {LightCustomer} from '../../interfaces/customers/light-customer';
import {LightEmployee} from '../../interfaces/employees/light-employee';
import {LightEmployeeFactory} from '../employees/light-employee-factory';
import {DateTime} from 'luxon';
import {LightUser} from '../../interfaces/core/light-user';
import {LightUserFactory} from '../core/light-user-factory';
import {UserService} from '../../services/core/user.service';

export class PrFormValueFactory {

  /**
   *
   * @param prFormValue
   */
  public static fromObject(prFormValue: any): PrFormValue {
    return new class implements PrFormValue {
      created: string = prFormValue.created;
      customer: LightCustomer = prFormValue.customer ? LightCustomerFactory.fromObject(prFormValue.customer) : null;
      customerId: number = prFormValue.customer_id;
      employee: LightEmployee = prFormValue.employee ? LightEmployeeFactory.fromObject(prFormValue.employee) : null;
      employeeId: number = prFormValue.employee_id;
      id: number = prFormValue.id;
      modified: string = prFormValue.modified;
      prFormControlId: number = prFormValue.pr_form_control_id;
      prProcessReportId: number = prFormValue.pr_process_report_id;
      value: any = prFormValue.value;
      prFormControlOption: PrFormControlOption = prFormValue.pr_form_control_option ?
        PrFormControlOptionFactory.fromObject(prFormValue.pr_form_control_option) : null;
      prFormControl: PrFormControl =
        prFormValue.pr_form_control ? PrFormControlFactory.fromObject(prFormValue.pr_form_control) : null;
      userId: number = prFormValue.user_id;
      user: LightUser = prFormValue.user ? LightUserFactory.fromObject(prFormValue.user) : null;
    };
  }

  /**
   *
   * @param prFormValues
   */
  public static fromArray(prFormValues: any[]): PrFormValue[] {
    return prFormValues.map(_prFormValue => this.fromObject(_prFormValue));
  }

  /**
   *
   * @param prFormValue
   */
  public static toRemote(prFormValue: PrFormValue): any {
    return  {
      id: prFormValue.id,
      value: prFormValue.value,
      customerId: prFormValue.customerId,
      employeeId: prFormValue.employeeId,
      pr_form_control_id: prFormValue.prFormControlId,
      pr_process_report_id: prFormValue.prProcessReportId
    };
  }

  /**
   *
   * @param prFormValues
   */
  public static toArray(prFormValues: PrFormValue[]): any[] {
    return prFormValues.map(_prFormValue => this.toRemote(_prFormValue));
  }

  /**
   *
   */
  public static new(): PrFormValue {
    return new class implements PrFormValue {
      created: string = DateTime.local().toISO();
      customer: LightCustomer = null;
      customerId: number = null;
      employee: LightEmployee = null;
      employeeId: number = null;
      id: number = null;
      modified: string = DateTime.local().toISO();
      prFormControlId: number = null;
      prProcessReportId: number = null;
      value: any = null;
      prFormControl: PrFormControl = null;
      prFormControlOption: PrFormControlOption = null;
      userId: number = UserService.getUser().id;
      user: LightUser = LightUserFactory.fromUser(UserService.getUser())
    };
  }
}
